import React, { forwardRef } from "react";

interface ChipButtonWideProps {
  id?: string;
  text: React.ReactNode;
  onClick?: () => void;
  className?: string;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  disabled?: boolean;
  /** Hold the pressed (caved-in) look while the button's dialog/menu is open. */
  active?: boolean;
  title?: string;
  style?: React.CSSProperties;
  type?: "button" | "submit" | "reset";
}

/**
 * Wide bubblewrap chip button, painted with the theme primary color. Same
 * elevated/press feel as ChipButton but full-width and sized for wide CTA
 * slots, with the same functional surface as DefaultButton — text, icon +
 * iconPosition, disabled, title, style, type. Styles live in globals.css
 * (.chip-elevated / .chip-primary / .chip-content / .chip-active /
 * .chip-disabled).
 */
const ChipButtonWide = forwardRef<HTMLButtonElement, ChipButtonWideProps>(
  function ChipButtonWide(
    {
      id,
      text,
      onClick,
      className = "",
      icon,
      iconPosition = "left",
      disabled = false,
      active = false,
      title,
      style,
      type = "button",
    },
    ref
  ) {
    return (
      <button
        ref={ref}
        id={id}
        type={type}
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
        title={title}
        style={style}
        className={`chip-elevated chip-primary chip-wide w-full flex items-center justify-center gap-2 px-5 h-11 text-fine font-bold ${
          iconPosition === "right" ? "flex-row-reverse" : ""
        } ${active ? "chip-active" : ""} ${className}`}
      >
        <span
          className={`chip-content ${
            iconPosition === "right" ? "flex-row-reverse" : ""
          }`}
        >
          {icon}
          {text}
        </span>
      </button>
    );
  }
);

export default ChipButtonWide;
